<div class="flex flex-col w-full h-full">
  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'command.newCondition' | transloco }}</div>
    <button mat-icon-button matDialogClose>
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <form [formGroup]="formGroup" class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>

    <!-- Fields -->
    <mat-form-field>
      <mat-label>{{ 'command.fields' | transloco }}</mat-label>
      <mat-select formControlName="field">
        @for (field of fields; track field) {
          <mat-option [value]="field.name">
            {{ field.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (exportFields.length > 0) {
      <mat-form-field animate.enter="slide-in-bottom">
        <mat-label>{{ 'command.exportField' | transloco }}</mat-label>
        <mat-select formControlName="exportField">
          @for (export of exportFields; track export) {
            <mat-option [value]="export">
              {{ export }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (field) {
      <mat-form-field animate.enter="slide-in-bottom">
        <mat-label>{{ 'command.condition' | transloco }}</mat-label>
        <mat-select formControlName="operator">
          @for (operator of operators; track operator) {
            <mat-option [value]="operator.code">
              {{ operator.value | localize }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (operator) {
      <div class="flex flex-col flex-auto" animate.enter="slide-in-bottom">
        @if (currentField.name === '_userId') {
          @if (operator === 'ONE_OF' || operator === 'NOT_ONE_OF') {
            <mat-form-field class="w-full">
              <mat-label>{{ 'command.values' | transloco }}</mat-label>
              <mat-chip-grid class="p-4" #chipList formControlName="operand">
                @for (chip of formGroup.get('operand')?.value ?? []; track chip; let i = $index) {
                  <mat-chip-row [value]="chip" [selectable]="false" [selected]="false" [removable]="true" (removed)="removeUser(i)">
                    {{ usersMap.get(chip) ?? chip }}
                    <mat-icon class="icon-size-5" matChipRemove [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>
                  </mat-chip-row>
                }
                <input [matChipInputFor]="chipList" [matChipInputAddOnBlur]="true" [formControl]="searchUserControl"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addUser($event)" [matAutocomplete]="ac">
                  <mat-autocomplete #ac="matAutocomplete" (optionSelected)="selectedUser($event)">
                    @for (user of filteredUsers; track user) {
                      <mat-option [value]="user.userId">
                        {{ user.displayName }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-chip-grid>
              </mat-form-field>
            }
          }
          @if (currentField.name === '_planningAreaId') {
            <mat-form-field class="w-full">
              <mat-label>{{ (operator === 'EQUALS' || operator === 'NOT_EQUALS' ? 'command.value' : 'command.values') | transloco }}</mat-label>
              <mat-select formControlName="operand" [multiple]="operator === 'EQUALS' || operator === 'NOT_EQUALS' ? false : true">
                @for (option of planningAreaList; track option) {
                  <mat-option [value]="option.planningArea">
                    {{ option.name | localize }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (currentField.name === '_taskTypeUri') {
            <mat-form-field class="w-full">
              <mat-label>{{ (operator === 'EQUALS' || operator === 'NOT_EQUALS' ? 'command.value' : 'command.values') | transloco }}</mat-label>
              <mat-select formControlName="operand" [multiple]="operator === 'EQUALS' || operator === 'NOT_EQUALS' ? false : true">
                @for (entry of taskTypeMap?.entries(); track location) {
                  <mat-optgroup [label]="entry[0]">
                    @for (tasktype of entry[1]; track tasktype.taskTypeId) {
                      <mat-option [value]="tasktype.uri">
                        {{ tasktype.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (operator === 'EQUALS' || operator === 'NOT_EQUALS') {
            @if (currentFieldIsText() || currentFieldIsNumber()) {
              <mat-form-field>
                <mat-label>{{ 'command.value' | transloco }}</mat-label>
                <input matInput [type]="currentFieldIsText() ? 'text' : 'number'" formControlName="operand">
              </mat-form-field>
            }
            <!-- Boolean types -->
            <div class="flex items-center">
              @if (fieldType === checkboxUri) {
                <mat-slide-toggle class="mr-4" color="primary" formControlName="operand">
                </mat-slide-toggle>
                <div class="cursor-pointer" (click)="operand = !operand">
                  <div class="leading-6 font-medium">{{ 'command.value' | transloco }}</div>
                </div>
              }
              @if (fieldType === tristateUri) {
                <ng-containter>
                  <mat-radio-group formControlName="operand">
                    @if (currentField) {
                      <mat-radio-button class="mr-4" [value]="'TRUE'">
                        {{ currentField.trueLabel ? (currentField.trueLabel | localize) : ('yes' | transloco) }}
                      </mat-radio-button>
                      <mat-radio-button class="mr-4" [value]="'FALSE'">
                        {{ currentField.falseLabel ? (currentField.falseLabel | localize) : ('no' | transloco) }}
                      </mat-radio-button>
                      <mat-radio-button [value]="'UNANSWERED'">
                        {{ currentField.emptyLabel ? (currentField.emptyLabel | localize) : ('unanswered' | transloco) }}
                      </mat-radio-button>
                    } @else if (currentExportField) {
                      <mat-radio-button class="mr-4" [value]="'TRUE'">
                        {{ currentExportField.trueLabel ? (currentExportField.trueLabel | localize) : ('yes' | transloco) }}
                      </mat-radio-button>
                      <mat-radio-button class="mr-4" [value]="'FALSE'">
                        {{ currentExportField.falseLabel ? (currentExportField.falseLabel | localize) : ('no' | transloco) }}
                      </mat-radio-button>
                      <mat-radio-button [value]="'UNANSWERED'">
                        {{ currentExportField.emptyLabel ? (currentExportField.emptyLabel | localize) : ('unanswered' | transloco) }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </ng-containter>
              }
              @if (fieldType === radioUri) {
                <mat-radio-group formControlName="operand">
                  @if (currentField) {
                    <mat-radio-button class="mr-4" [value]="true">
                      {{ currentField.trueLabel ? (currentField.trueLabel | localize) : ('yes' | transloco) }}
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                      {{ currentField.falseLabel ? (currentField.falseLabel | localize) : ('no' | transloco) }}
                    </mat-radio-button>
                  } @else if (currentExportField) {
                    <mat-radio-button class="mr-4" [value]="true">
                      {{ currentExportField.trueLabel ? (currentExportField.trueLabel | localize) : ('yes' | transloco) }}
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                      {{ currentExportField.falseLabel ? (currentExportField.falseLabel | localize) : ('no' | transloco) }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              }
            </div>
            <!-- Select/Autocomplete types -->
            @if (currentFieldIsSelect() || currentFieldIsAutocomplete()) {
              <mat-form-field>
                <mat-label>{{ 'command.value' | transloco }}</mat-label>
                <mat-select formControlName="operand">
                  @if (currentExportField) {
                    @for (option of currentExportField.option; track option) {
                      <mat-option [value]="option.code">
                        {{ option.value | localize }}
                      </mat-option>
                    }
                  } @else if (currentField) {
                    @for (option of currentField.option; track option) {
                      <mat-option [value]="option.code">
                        {{ option.value | localize }}
                      </mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
            }
          }
          <!-- Date types -->
          @if (fieldType === datepickerUri && (operator === 'EQUALS' || operator === 'NOT_EQUALS' || operator === 'GREATERTHAN' || operator === 'LESSTHAN')) {
            <mat-form-field>
              <mat-label>{{ 'command.value' | transloco }}</mat-label>
              <input matInput formControlName="operand" [matDatepicker]="datepicker" (click)="openDatepickerOnClick(datepicker)"
                (dateChange)="dateChange($event)" />
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker></mat-datepicker>
              </mat-form-field>
            }
            @if (fieldType === timepickerUri && (operator === 'EQUALS' || operator === 'NOT_EQUALS' || operator === 'GREATERTHAN' || operator === 'LESSTHAN')) {
              <div class="flex flex-col w-full mb-3">
                <div class="leading-6 font-medium">{{ 'command.value' | transloco }}</div>
                <div class="flex flex-row w-full items-center">
                  <timepicker-autofill-component [control]="formGroup.get('operand')" [allowManual]="true" [style]="'HH:mm:ss'">
                  </timepicker-autofill-component>
                </div>
              </div>
            }
            @if (fieldType === timerangesUri) {
            }
            @if (currentFieldIsNumber() && (operator === 'GREATERTHAN' || operator === 'LESSTHAN')) {
              <mat-form-field>
                <mat-label>{{ 'command.value' | transloco }}</mat-label>
                <input matInput type="number" formControlName="operand">
              </mat-form-field>
            }
            @if (operator === 'ONE_OF' || operator === 'NOT_ONE_OF') {
              <!-- Text types -->
              @if (!currentFieldIsSelect() && !currentFieldIsAutocomplete() && !currentFieldIsTrigger()) {
                <mat-form-field>
                  <mat-label>{{ 'command.values' | transloco }}</mat-label>
                  <mat-chip-grid #chipGridText formControlName="operand">
                    @for (op of operand ?? []; track op; let i = $index) {
                      <mat-chip-row (removed)="removeFromChiplist(index)">
                        {{ op }}
                        <mat-icon class="icon-size-5" matChipRemove
                        svgIcon="heroicons_solid:minus-circle"></mat-icon>
                      </mat-chip-row>
                    }
                    <input [matChipInputFor]="chipGridText" [formControl]="chiplistControl" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addToChiplist($event)">
                    </mat-chip-grid>
                  </mat-form-field>
                }
                <!-- Select/Autocomplete types -->
                @if (currentFieldIsSelect() || currentFieldIsAutocomplete()) {
                  <mat-form-field>
                    <mat-label>{{ 'command.values' | transloco }}</mat-label>
                    <mat-chip-grid #chipGridSelect>
                      @for (op of operand ?? []; track op; let i = $index) {
                        <mat-chip-row (removed)="removeFromChiplist(i)">
                          {{ getChipCaption(op) }}
                          <mat-icon class="icon-size-5" matChipRemove
                          svgIcon="heroicons_solid:minus-circle"></mat-icon>
                        </mat-chip-row>
                      }
                      <input [matChipInputFor]="chipGridSelect" [formControl]="chiplistControl" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="$event.input.value = ''" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAutocomplete($event)">
                          @for (option of filteredOptions; track option) {
                            <mat-option [value]="option.code" [disabled]="$safeNavigationMigration(operand?.includes(option.code))">
                              {{ option.value | localize }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-chip-grid>
                    </mat-form-field>
                  }
                }
              </div>
            }
          </form>

          <!-- Footer -->
          <div class="flex flex-0 items-center justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
            <button mat-stroked-button matDialogClose>{{ 'cancel' | transloco }}</button>
            <button mat-flat-button color="primary" (click)="save()">{{ 'save' | transloco }}</button>
          </div>
        </div>